<template>
  <AppShell>
    <div class="page-head">
      <h1>Клиенты</h1>
      <v-btn color="primary" prepend-icon="mdi-account-plus-outline" @click="editClient({})">Клиент</v-btn>
    </div>
    <v-card variant="flat">
      <v-table>
        <thead><tr><th>Имя</th><th>Телефон</th><th>Заметки</th><th></th></tr></thead>
        <tbody>
          <tr v-for="client in clients" :key="client.id">
            <td>{{ client.name }}</td><td>{{ client.phone }}</td><td>{{ client.notes }}</td>
            <td class="table-actions">
              <v-btn icon="mdi-play-circle-outline" variant="text" @click="startSession(client)" />
              <v-btn icon="mdi-pencil-outline" variant="text" @click="editClient(client)" />
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-dialog v-model="linkVisible" max-width="680">
      <v-card>
        <v-card-title>Ссылка для клиента</v-card-title>
        <v-card-text class="form-grid">
          <v-text-field v-model="sessionLink" label="Билет активен до 6 часов" readonly append-inner-icon="mdi-content-copy" @click:append-inner="copyLink" />
          <v-alert v-if="copyMessage" type="success" variant="tonal">{{ copyMessage }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="linkVisible = false">Закрыть</v-btn>
          <v-btn prepend-icon="mdi-content-copy" color="primary" variant="tonal" @click="copyLink">Скопировать</v-btn>
          <v-btn prepend-icon="mdi-table-account" color="primary" @click="openSession">Открыть сессию</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ClientEditor v-model="editor" :client="draft" @save="saveClient" />
  </AppShell>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { api, unwrap } from '../api/http';
import AppShell from '../components/AppShell.vue';
import ClientEditor from '../components/ClientEditor.vue';
const router = useRouter();
const clients = ref([]);
const editor = ref(false);
const draft = ref({});
const sessionLink = ref('');
const sessionId = ref(null);
const linkVisible = ref(false);
const copyMessage = ref('');
async function loadClients() { clients.value = unwrap(await api.get('/api/clients')); }
function editClient(client) { draft.value = { ...client }; editor.value = true; }
async function saveClient(form) {
  if (form.id) await api.put(`/api/clients/${form.id}`, form); else await api.post('/api/clients', form);
  editor.value = false;
  await loadClients();
}
async function startSession(client) {
  const data = unwrap(await api.post('/api/sessions', { client_id: client.id }));
  sessionLink.value = `${window.location.origin}/session/${data.token}`;
  sessionId.value = data.session.id;
  copyMessage.value = '';
  linkVisible.value = true;
}
async function copyLink() {
  await navigator.clipboard.writeText(sessionLink.value);
  copyMessage.value = 'Ссылка скопирована';
}
function openSession() {
  linkVisible.value = false;
  router.push(`/sessions/${sessionId.value}`);
}
onMounted(loadClients);
</script>

